import axios from "axios";
import { useLayoutEffect, useState } from "react";

const ShowImage = (props) => {
    const [image, setImage] = useState([]);

    useLayoutEffect(() => {
        if (props.editDataValue&&props.pageType === "edit" && props.editDataValue.length > 0) {
            getImage();
        }
    }, [props.pageType]);

    async function getImage() {
        const fetchingUrl = props.editDataValue.map(url => props.item.get + url)

        axios.all(
            fetchingUrl.map((endpoint) =>
                axios.get(endpoint, {
                    responseType: "blob",
                })
            )
        ).then((res) => {
            res.map((item) => {
                var reader = new window.FileReader();
                reader.readAsDataURL(item.data);
                reader.onload = function (e) {
                    setImage(prevState=>[...prevState,reader.result]);
                };
            });
        })
    }
    return (
        <div className="flex flex-wrap gap-y-3 gap-x-3 w-full">
            {image && image.map((item, index) => (
                <div className="relative" key={index}>
                    <img
                        src={item}
                        id={item}
                        key={index}
                        className=" rounded-xl border-dashed border-2 border-[#5ba9aa] p-1 w-[100px] sm:w-[150px]"
                        alt=""
                    />
                </div>
            ))}
        </div>
    );
}

export default ShowImage;